export const LocationTypes = {
  CLINIC: { text: 'Clinic', value: 'clinic', api: 'setLocations', index: 'ClinicLocations' },
  SERVICE: { text: 'Service', value: 'service', api: 'setServiceLocations', index: 'ServiceLocations' }
}

export const LocationTypeOptions = [
  LocationTypes.CLINIC,
  LocationTypes.SERVICE
]
